(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Icon = svs.ui.ReactIcon;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  IconButton = _svs$ui.ReactIconButton;
const buildInviteLinkUrl = svs.arena.pages.teams.helpers.buildInviteLinkUrl;
const _svs$arena$pages$team = svs.arena.pages.teams.dialogs,
  showCopyInviteLinkFailToaster = _svs$arena$pages$team.showCopyInviteLinkFailToaster,
  showCopyInviteLinkSuccessToaster = _svs$arena$pages$team.showCopyInviteLinkSuccessToaster,
  showShareFailedToaster = _svs$arena$pages$team.showShareFailedToaster;
const TeamShowLink = _ref => {
  let _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? true : _ref$isExpanded,
    teamId = _ref.teamId,
    _ref$isCreate = _ref.isCreate,
    isCreate = _ref$isCreate === void 0 ? false : _ref$isCreate;
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLinkOld = _React$useState2[0],
    setIsLinkOld = _React$useState2[1];
  const _React$useState3 = React.useState('copy'),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    copyIcon = _React$useState4[0],
    setCopyIcon = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    disableShareButton = _React$useState6[0],
    setDisableShareButton = _React$useState6[1];
  const linkId = inviteIds.find(item => item.teamId === teamId);
  React.useEffect(() => {
    svs.arena.logger.debug('TeamShowLink, useEffect running');
    if (isExpanded && linkId !== null && linkId !== void 0 && linkId.validTo) {
      const isTooOld = dateFns.compareAsc(Date.now(), dateFns.addDays(dateFns.parseISO(linkId.validTo), -5));
      setIsLinkOld(isTooOld === 1);
    }
  }, [isExpanded, linkId.validTo]);
  const copyLinkToClipBoard = async () => {
    svs.arena.logger.debug('TeamShowLink, copyLinkToClipBoard');
    svs.ui.loader.show();
    try {
      await navigator.clipboard.writeText(buildInviteLinkUrl(linkId.linkId));
      const track = {
        category: 'spela-tillsammans',
        action: isCreate ? 'new_team' : 'invite_members',
        opt_label: 'copy_link'
      };
      svs.components.analytics.trackEvent(track);
    } catch (error) {
      showCopyInviteLinkFailToaster();
      svs.ui.loader.hide();
      return;
    }
    svs.ui.loader.hide();
    setCopyIcon('checkmark');
    setDisableShareButton(true);
    setTimeout(() => {
      setCopyIcon('copy');
      setDisableShareButton(false);
    }, 3000);
    showCopyInviteLinkSuccessToaster();
  };
  const shareLink = async () => {
    if (navigator.canShare) {
      try {
        await navigator.share({
          title: 'Svenska Spel Tur - Spela tillsammans',
          text: 'svenskaspel.se/spela-tillsammans',
          url: buildInviteLinkUrl(linkId.linkId)
        });
        const track = {
          category: 'spela-tillsammans',
          action: isCreate ? 'new_team' : 'invite_members',
          opt_label: 'copy_link'
        };
        svs.components.analytics.trackEvent(track);
      } catch (error) {
        if (error.code !== 11) {
          showShareFailedToaster();
        }
      }
    } else {
      copyLinkToClipBoard();
    }
  };
  const daysLeft = () => dateFns.differenceInCalendarDays(dateFns.parseISO(linkId.validTo), Date.now());
  return React.createElement("div", null, linkId && React.createElement("div", {
    className: "align-center f-body"
  }, React.createElement("div", {
    className: "bg-tur-100 padding-1 u-border-radius-4 margin-v u-flex u-flex-justify-content-center w-100"
  }, React.createElement("div", null, buildInviteLinkUrl(linkId.linkId)), React.createElement(IconButton, {
    "aria-label": "Kopiera l\xE4nken",
    disabled: disableShareButton,
    onClick: copyLinkToClipBoard,
    type: "button"
  }, React.createElement(Icon, {
    className: "padding-1",
    icon: copyIcon
  }))), isLinkOld && React.createElement("div", {
    className: "f-italic align-left"
  }, "L\xE4nken \xE4r giltig i ".concat(daysLeft(), " ").concat(daysLeft() === 1 ? 'dag' : 'dagar', " till.")), React.createElement(Button, {
    block: true,
    className: "margin-top-1 margin-bottom-1",
    disabled: disableShareButton,
    inverted: true,
    onClick: shareLink,
    size: 300
  }, "Dela l\xE4nk")));
};
svs.arena.pages.teams.components.TeamShowLink = TeamShowLink;

 })(window);